var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPointer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.664,
    height: 22.256,
    viewBox: "0 0 14.664 22.256",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-mouse-pointer",
    "data-name": "Icon awesome-mouse-pointer",
    d: "M.7,13H4.894L2.689,18.374a.734.734,0,0,0,.373.948L5,20.168a.7.7,0,0,0,.922-.384l2.1-5.1L11.445,18.2a.7.7,0,0,0,1.2-.508V.723a.7.7,0,0,0-1.2-.508L.21,11.771A.724.724,0,0,0,.7,13Z",
    transform: "translate(1.022 1.025)",
    fill: "none",
    stroke: "#b6b6c7",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPointer);
export default __webpack_public_path__ + "static/media/pointer.5de4864a5076c3aec9ea3f0971985001.svg";
export { ForwardRef as ReactComponent };